import { word } from "@modules/core/utils/i18n"
import { type OnOffProgramProgressionDto } from "@modules/programs/gateway/onOffProgramProgressionDto"
import { ProgramProgressionStatus } from "@modules/programs/types/programOnOffTypes"
import dayjs from "dayjs"

type OnOffProgramProgressionState = Omit<OnOffProgramProgressionEntity, "getWordingPause" | "getWordingStarted">

export class OnOffProgramProgressionEntity {
  programId: string
  userId: string
  currentIndex: number
  duration: number
  startedAt: Date | null
  stoppedAt: Date | null
  status: ProgramProgressionStatus

  private constructor(onOffProgramProgression: OnOffProgramProgressionState) {
    this.programId = onOffProgramProgression.programId
    this.userId = onOffProgramProgression.userId
    this.currentIndex = onOffProgramProgression.currentIndex
    this.duration = onOffProgramProgression.duration
    this.startedAt = onOffProgramProgression.startedAt ? new Date(onOffProgramProgression.startedAt) : null
    this.stoppedAt = onOffProgramProgression.stoppedAt ? new Date(onOffProgramProgression.stoppedAt) : null
    this.status = onOffProgramProgression.status
  }

  static fromDto(dto: OnOffProgramProgressionDto): OnOffProgramProgressionEntity {
    return new OnOffProgramProgressionEntity({
      programId: dto.programId,
      userId: dto.userId,
      currentIndex: dto.currentIndex,
      duration: dto.duration,
      startedAt: dto.startedAt ? new Date(dto.startedAt) : null,
      stoppedAt: dto.stoppedAt ? new Date(dto.stoppedAt) : null,
      status: dto.status,
    })
  }

  getWordingPause(): string {
    if (!this.stoppedAt) return ""

    const pausedAt = dayjs(this.stoppedAt).format("L")

    return word("onOffProgramProgressionEntity.information.pause", {
      pausedAt,
    })
  }

  getWordingStarted(): string {
    if (!this.startedAt) return ""

    const startedAt = dayjs(this.startedAt).format("L")

    return word("onOffProgramProgressionEntity.information.start", {
      startedAt,
    })
  }
}
